import * as React from 'react';
import {renderReact} from 'hypernova-react';
import {I18nContext, I18nManager} from '@shopify/react-i18n';
import {Locations} from './Locations';

const manager = new I18nManager({locale: 'en-CA'});

export function LocationsSection(props) {
  return (
    <I18nContext.Provider value={manager}>
      <Locations {...props} />
    </I18nContext.Provider>
  );
}

export default renderReact('Locations', LocationsSection);
